module.exports = __webpack_public_path__ + "img/add-table.52d260d4.png";